import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { PaymentDebtModalComponent } from '@components/payment-debt-modal/payment-debt-modal.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CanPipe } from 'ability';
import { I18NextService } from 'angular-i18next';
import { ButtonComponent, MbsSize, ModalComponent, ModalFooterDirective, ModalService } from 'mbs-ui-kit';
import { POST_PAYMENT_TOKEN } from 'mbs-ui-shared/src/lib/tokens/post-payment.token';
import { PaymentMethodButtonComponent } from 'mbs-ui-shared@components/licenses/components/payment-method-button/payment-method-button.component';
import { AuthFacade } from 'mbs-ui-shared@facades/auth.facade';
import { StorageAccountState } from 'mbs-ui-shared@models/storage-accounts/StorageAccountState';
import { UnifiedBillingAccount, UnifiedBillingAccountType } from 'mbs-ui-shared@models/storage-accounts/UnifiedBillingAccount';
import { StorageAccountsService } from 'mbs-ui-shared@services/storage-accounts/storage-accounts.service';
import moment from 'moment';
import { Observable, noop } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { UbSubscribeService } from '../ub-subscribe.service';

@UntilDestroy()
@Component({
  selector: 'mbs-ub-cancel-deletion',
  templateUrl: './ub-cancel-deletion.component.html',
  styles: [],
  imports: [ButtonComponent, CommonModule, PaymentMethodButtonComponent, CanPipe, ModalComponent, ModalFooterDirective]
})
export class UbCancelDeletionComponent implements OnInit {
  private storageService = inject(StorageAccountsService);
  private modalService = inject(ModalService);
  private i18nextService = inject(I18NextService);
  private auth = inject(AuthFacade);
  ubSubscribe = inject(UbSubscribeService);
  isPostPayment = inject<Observable<boolean>>(POST_PAYMENT_TOKEN);

  public readonly size = MbsSize;
  public storageAccount: UnifiedBillingAccount;
  public loading = false;

  public StorageAccountState = StorageAccountState;
  public UnifiedBillingAccountType = UnifiedBillingAccountType;

  // also should same in ub-notifications.components.ts
  public durationDeleteDays;

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;

  public get showFooter(): boolean {
    return (
      this.storageAccount &&
      this.ubSubscribe.canRestoreTypes.concat(this.ubSubscribe.readonlyTypes).includes(this.storageAccount.usageTypeByLifeCycle)
    );
  }

  ngOnInit(): void {
    this.durationDeleteDays = moment.duration(this.storageAccount.usageTypeDaysCount, 'days').format('d [days]');
  }

  handleResolve(): void {
    this.loading = true;
    this.storageService
      .cancelDeletionUb(this.storageAccount.id)
      .pipe(
        finalize(() => (this.loading = false)),
        untilDestroyed(this)
      )
      .subscribe(() => {
        // TODO NESTED SUBSCRIPTIONS
        this.storageService.getUnifiedBillings().subscribe(); // prettier
        this.baseModal.save();
      });
  }

  handleSubscribe(): void {
    // close current then show switchCommercial
    this.baseModal.close();
    this.ubSubscribe.showSwitchCommercial(this.storageAccount);
  }

  public openPaymentDebtModal() {
    this.baseModal.close();

    this.modalService
      .openCustom(PaymentDebtModalComponent, {
        data: {
          title: this.i18nextService.t('shared:paymentDebtModal:title', {
            format: 'title'
          }),
          userId: this.auth.currentUserValue.Id
        },
        size: MbsSize.sm
      })
      .finally(noop);
  }
}
